import moment from 'moment'

import { LOCK_TIME } from '../constants/staking'

const formatDate = (value, formatting, _) => {
  return moment.utc(value).local().format(formatting)
}

const nextTargetTime = (day = '', hour) => {
  const currentDate = moment.utc()
  let nextWeek = moment
    .utc()
    .day(day)
    .hour(hour)
    .minute(0)
    .second(0)
    .millisecond(0)
  if (nextWeek.isBefore(currentDate)) {
    nextWeek = nextWeek.add(7, 'days')
  }
  return formatTimeDelta(nextWeek.diff(currentDate))
}

const isTimePassed = (timestamp) => {
  const now = moment()
  const end = moment.unix(timestamp)
  return end.isBefore(now) || now.isAfter(end)
}

const nextTargetTimeStartTime = ({ startTime, endTime }) => {
  const now = moment().unix()
  const timeLeftDefault = '0d 0h 0m 0s'
  if (now < startTime) {
    return {
      active: false,
      timeLeft: timeLeftDefault,
      progress: 0
    }
  }
  if (now >= endTime) {
    return {
      active: false,
      timeLeft: timeLeftDefault,
      progress: 100
    }
  }
  const duration = moment.duration(endTime - now, 'seconds')
  const totalDuration = endTime - startTime
  const elapsed = now - startTime
  const days = Math.floor(duration.asDays())
  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = duration.seconds()
  return {
    active: true,
    timeLeft: `${days}d ${hours}h ${minutes}m ${seconds}s`,
    progress: (elapsed / totalDuration) * 100
  }
}

const getMinus180DaysTimestamp = (unixTimestamp) => {
  return moment.unix(unixTimestamp).subtract(LOCK_TIME, 'hours').unix()
}

const formatTimeDelta = (timeDelta, showDays = false) => {
  // Convert milliseconds to days, hours, and minutes
  const days = Math.floor(timeDelta / (1000 * 60 * 60 * 24))
  const hours = Math.floor(
    (timeDelta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  )
  const minutes = Math.floor((timeDelta % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((timeDelta % (1000 * 60)) / 1000)

  // Format the result
  return `${showDays ? `${days}d ` : ''}${hours}h ${minutes}m ${seconds}s`
}

const dateDiffInHours = (date) => {
  return moment.utc().diff(moment.utc(date), 'hours', true)
}

export {
  formatDate,
  formatTimeDelta,
  getMinus180DaysTimestamp,
  isTimePassed,
  nextTargetTime,
  nextTargetTimeStartTime,
  dateDiffInHours
}
